export default "__VITE_ASSET__BZF0agzv__"